module.exports = __webpack_public_path__ + "assets/brand-edge-filter.5da54084.svg";